import { useState, useEffect, useRef } from "react";
import { Plus, ChefHat, BookOpen } from "lucide-react";

/**
 * Floating Action Button con menu a due opzioni:
 * - Crea piatto (manuale)
 * - Scegli dal catalogo (>100 ricette pronte)
 */
export function FABWithMenu({ onCreate, onPickCatalog, testid = "fab-menu" }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return;
        const onDoc = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", onDoc);
        return () => document.removeEventListener("mousedown", onDoc);
    }, [open]);

    return (
        <div
            ref={ref}
            className="fixed right-5 bottom-24 lg:bottom-10 lg:right-10 z-40"
        >
            {open && (
                <div
                    className="absolute right-0 bottom-16 w-[260px] rounded-2xl bg-paper border border-brand-line shadow-card overflow-hidden animate-fade-up"
                    data-testid={`${testid}-actions`}
                >
                    <button
                        type="button"
                        onClick={() => {
                            setOpen(false);
                            onPickCatalog?.();
                        }}
                        data-testid={`${testid}-pick`}
                        className="w-full text-left px-4 py-3.5 flex items-start gap-3 hover:bg-brand-cream transition-colors border-b border-brand-line"
                    >
                        <div className="h-9 w-9 rounded-full bg-brand-gold/15 text-brand-gold flex items-center justify-center shrink-0">
                            <BookOpen size={16} />
                        </div>
                        <div>
                            <div className="text-[13px] font-semibold text-brand-ink">Scegli piatto</div>
                            <div className="text-[11px] text-brand-muted leading-snug">
                                Dal nostro catalogo di 100+ ricette
                            </div>
                        </div>
                    </button>
                    <button
                        type="button"
                        onClick={() => {
                            setOpen(false);
                            onCreate?.();
                        }}
                        data-testid={`${testid}-create`}
                        className="w-full text-left px-4 py-3.5 flex items-start gap-3 hover:bg-brand-cream transition-colors"
                    >
                        <div className="h-9 w-9 rounded-full bg-brand-navy text-brand-gold flex items-center justify-center shrink-0">
                            <ChefHat size={16} />
                        </div>
                        <div>
                            <div className="text-[13px] font-semibold text-brand-ink">Crea piatto</div>
                            <div className="text-[11px] text-brand-muted leading-snug">
                                Costruisci una ricetta da zero
                            </div>
                        </div>
                    </button>
                </div>
            )}
            <button
                type="button"
                onClick={() => setOpen((s) => !s)}
                aria-label="Aggiungi piatto"
                data-testid={`${testid}-toggle`}
                className={`h-14 w-14 rounded-full bg-brand-gold text-brand-navy shadow-gold flex items-center justify-center hover:bg-brand-goldDark hover:scale-105 active:scale-95 transition-all duration-200 ${open ? "rotate-45" : ""}`}
            >
                <Plus size={24} strokeWidth={2.6} />
            </button>
        </div>
    );
}
